import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { IndustryConversionForm } from "./Main";
import { useGetIndustryConversionUpdateQuery } from "../../features/api";
import { IndustryConversion } from "../../features/api-interfaces";

export const Update = () => {
  // 業態変換情報取得API呼び出し
  const { no } = useParams();
  const conversionRuleNo = no as string;
  let { data, refetch } = useGetIndustryConversionUpdateQuery(
    Number(conversionRuleNo)
  );
  const registeredData = data as IndustryConversion;

  useEffect(() => {
    refetch();
  }, [refetch]);

  return (
    <IndustryConversionForm registeredData={registeredData} refetch={refetch} />
  );
};
